import React from 'react'
import {Helmet} from 'react-helmet'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const Fonts = () => {
    const fonts = [
        {
            family: 'UniversLTStd',
            weight: 'bold',
            style: 'normal',
            fileName: 'UniversLTStd-BoldCn'
        },
        {
            family: 'UniversLTStd',
            weight: 300,
            style: 'normal',
            fileName: 'UniversLTStd-LightCn'
        }
    ]

    const fontFaceStyles = fonts.map(({family, weight, style, fileName}) => {
        const basePath = getAssetUrl(`static/fonts/UniversLTStd/${fileName}`)
        return `@font-face {
            font-family: '${family}';
            src: url('${basePath}.woff2') format('woff2'),
                 url('${basePath}.woff') format('woff'),
                 url('${basePath}.ttf') format('truetype');
            font-weight: ${weight};
            font-style: ${style};
            font-display: swap;
        }`
    })

    return (
        <Helmet>
            <style>{fontFaceStyles.join(' ')}</style>
        </Helmet>
    )
}

Fonts.displayName = 'Fonts'

export default Fonts
